import { Col, Form, Input, Row, Select } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import React from 'react';

const FormItem = Form.Item;
const Option = Select.Option;

interface IProps extends FormComponentProps {}

class SetStripeCustomerForm extends React.Component<IProps>{
    public render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="vertical">
                <Row gutter={48}>
                    <Col span={12}>
                        <FormItem label={'New Stripe Customer'}>
                            {getFieldDecorator('stripeCustomerID', {
                                initialValue: '',
                                rules: [
                                    { validator: this.validateMethod }
                                ],
                            })(
                                <div><Input className="input" /></div>
                            )}
                        </FormItem>
                        <FormItem label={'Stripe Platform'}>
                            {getFieldDecorator('stripeRegion', {
                                initialValue: -1,
                                rules: [
                                    { validator: this.validatePlatform }
                                ],
                            })(
                                <Select>
                                    <Option value={-1}>Select Stripe Platform</Option>
                                    <Option value={0}>SharpSpring Tech</Option>
                                    <Option value={1}>InterInbox</Option>
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    private validateMethod = (rule: any, value: any, callback: any) => {
        // Just validates that some value was provided. The backend can verify if it's an actual Stripe customer
        if (!value){
            callback('Please enter a Stripe customer ID')
        } 

        callback();
    }

    private validatePlatform = (rule: any, value: any, callback: any) => {
        if (value < 0){
            callback('Please select a platform')
        } 

        callback();
    }
}

export default Form.create<IProps>()(SetStripeCustomerForm);
